import axios from "@utils/axios"
import Translate from '../components/translate/conf';

export default class OltReport {

    gData = { }

    constructor() {
        this.doInitData();
    }

    getNewReport = () => new Object({ 
        status: '-'
    })

    doInitData = () => {
        for(let i=0;i<8;i++){
            this.gData['slot'+(i+1)] = this.getNewReport()
        }
    }

    doLoadData = () => {
        return new Promise(async (resolve,reject) => {
            try {
                let res = await axios('/api/slottable');
                if( res.data.data !== undefined ){
                    this.setReportOnlineOffline(res.data.data)
                }
                resolve(this)
            } catch(e) {
                console.log(e)
            }
            reject(null)
        })
    }

    setReportOnlineOffline = (data) => {
        const onlineStatus = <div className="text-online"><Translate transVar='Dashboard.Online' /></div>
        const offlineStatus = <div className="text-offline"><Translate transVar='Dashboard.Offline' /></div>
        let obj;
        for(let i=0;i<data.length;i++){
            obj = this.gData['slot'+parseInt(data[i].ucSlotIndex)];
            obj.status = (data[i].ucSlotStatus === '1') ? onlineStatus : offlineStatus;
            this.gData['slot'+parseInt(data[i].ucSlotIndex)] = obj
        }
    }

    getSlotData = (slotNumber) => {
        if( slotNumber > 0 && slotNumber < 9 ){
            return this.gData['slot'+parseInt(slotNumber)]
        }
        throw ("Slot("+slotNumber+") number out of range")
    }
}